export default __webpack_public_path__ + "static/media/Feel Fit.3e1b7782.png";